import './index.sass';

export default () => {
  const $root = $('.aside-filters');
  const $button = $root.find('.aside-filters__btn-wrap button');
  const $select = $root.find('.js-select-search-multiple');

  $select.on("select2:select select2:unselect", function () {
    const selected = [];

    $select.each(index => {
      selected.push($($select[index]).val().length);
    })

    if(selected.some(elem => elem !== 0)) {
      $('.aside-filters__btn-wrap').addClass('aside-filters__btn-wrap--show');
      $button.removeAttr('disabled', 'disabled');
    } else {
      $('.users__form').trigger('submit');
      // $('.aside-filters__btn-wrap').removeClass('aside-filters__btn-wrap--show');
      // $button.attr('disabled', 'disabled');
    }
  })
}